import { render, staticRenderFns } from "./IncomeList.vue?vue&type=template&id=1ae5d2a5&"
import script from "./IncomeList.vue?vue&type=script&lang=js&"
export * from "./IncomeList.vue?vue&type=script&lang=js&"
import style0 from "./IncomeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports